import { useState } from 'react'

import { ChangeEvent } from 'react'

export function useTextInput(initialValue: string = '') {
  const [value, setValue] = useState(initialValue)
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value)
  return [value, handleChange, setValue] as const
}
